/** KPI stat card used across dashboards. */
import { Card } from "@/components/ui/card";

export function Stat({ label, value, icon, accent }) {
  const accents = {
    sky: "bg-sky-50 text-sky-700 border-sky-200",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200",
    amber: "bg-amber-50 text-amber-700 border-amber-200",
    violet: "bg-violet-50 text-violet-700 border-violet-200",
  };
  return (
    <Card data-testid={`stat-${label.toLowerCase()}`} className="p-5 flex items-center gap-4">
      <div className={`w-11 h-11 rounded-xl grid place-items-center border ${accents[accent]}`}>{icon}</div>
      <div>
        <div className="text-xs uppercase tracking-widest text-slate-400 font-bold">{label}</div>
        <div className="font-heading font-bold text-2xl text-slate-900 tabular-nums">{value}</div>
      </div>
    </Card>
  );
}
